(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(440);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Utils_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3091);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);





var ContactForm = function(param) {
    var title = param.title, subtitle = param.subtitle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), result = ref[0], setResult = ref[1];
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(e) {
            var response, result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setResult("Sending");
                        return [
                            4,
                            fetch("https://api.web3forms.com/submit", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json"
                                },
                                body: JSON.stringify({
                                    access_key: "be1e603e-89d8-4469-8610-8b5b79eeeb8d",
                                    subject: e.target.subject.value,
                                    email: e.target.email.value,
                                    message: e.target.message.value
                                })
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        result = _state.sent();
                        if (result.success) {
                            console.log("Success");
                            setResult("Success");
                        } else {
                            setResult("Error");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "mb-4 text-4xl tracking-tight font-extrabold text-center",
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mb-8 lg:mb-16 font-light text-center sm:text-xl",
                children: subtitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "email",
                                className: "block mb-2 text-sm font-medium",
                                children: "Your email"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "email",
                                id: "email",
                                name: "email",
                                className: "shadow-sm input input-bordered w-full",
                                placeholder: "name@aiexcelbot.com",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "subject",
                                className: "block mb-2 text-sm font-medium",
                                children: "Subject"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "text",
                                id: "subject",
                                name: "subject",
                                className: "input input-bordered w-full",
                                placeholder: "Let us know how we can help you",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "sm:col-span-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "message",
                                className: "block mb-2 text-sm font-medium",
                                children: "Your message"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                                id: "message",
                                name: "message",
                                rows: 6,
                                className: "block p-2.5 w-full textarea textarea-bordered",
                                placeholder: "Leave a comment..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            result === "Success" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "border border-success p-4 rounded-lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Email sent successfully. We will write back to you soon."
                                })
                            }),
                            result === "Error" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "border border-error p-4 rounded-lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Error sending email. Please try again"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Utils_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "submit",
                        loading: result === "Sending",
                        children: "Send Message"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactForm);


/***/ }),

/***/ 9057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



var Footer = function(param) {
    var _handelScrollToContact = param.handelScrollToContact, handelScrollToContact = _handelScrollToContact === void 0 ? function() {} : _handelScrollToContact, _handelScrollToFeatures = param.handelScrollToFeatures, handelScrollToFeatures = _handelScrollToFeatures === void 0 ? function() {} : _handelScrollToFeatures, _handelScrollToPricing = param.handelScrollToPricing, handelScrollToPricing = _handelScrollToPricing === void 0 ? function() {} : _handelScrollToPricing;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var handleRouteToHome = function(anchor) {
        router.push("/?anchor=".concat(anchor));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: "footer p-10 max-w-6xl mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-2xl font-bold",
                        children: "AI Excel Bot"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "A product by Query Labs."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            "Copyright \xa9 ",
                            new Date().getFullYear(),
                            " - All right reserved"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "link link-hover",
                        onClick: function() {
                            return router.pathname === "" ? handelScrollToFeatures() : handleRouteToHome("features");
                        },
                        children: "Features"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "link link-hover",
                        onClick: function() {
                            return router.pathname === "" ? handelScrollToPricing() : handleRouteToHome("pricing");
                        },
                        children: "Pricing"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "link link-hover",
                        onClick: function() {
                            return router.pathname === "" ? handelScrollToContact() : handleRouteToHome("contact");
                        },
                        children: "Contact"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/terms-of-use",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "link link-hover",
                            children: "Terms of use"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/privacy-policy",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "link link-hover",
                            children: "Privacy policy"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 9419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 161 modules
var motion = __webpack_require__(2070);
// EXTERNAL MODULE: ./utils/AuthContext.tsx
var AuthContext = __webpack_require__(6864);
// EXTERNAL MODULE: ./components/Utils/Button.tsx
var Button = __webpack_require__(3091);
;// CONCATENATED MODULE: ./components/Navbar/Navbar.tsx






var Navbar = function(param) {
    var _handelScrollToContact = param.handelScrollToContact, handelScrollToContact = _handelScrollToContact === void 0 ? function() {} : _handelScrollToContact, _handelScrollToFeatures = param.handelScrollToFeatures, handelScrollToFeatures = _handelScrollToFeatures === void 0 ? function() {} : _handelScrollToFeatures, _handelScrollToPricing = param.handelScrollToPricing, handelScrollToPricing = _handelScrollToPricing === void 0 ? function() {} : _handelScrollToPricing;
    var router = (0,next_router.useRouter)();
    var ref = (0,AuthContext/* useUser */.a)(), user = ref.user, logOut = ref.logOut;
    var handleRouteToHome = function(anchor) {
        router.push("/?anchor=".concat(anchor));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "transition-all ease-in flex justify-between items-center py-4 px-8 max-w-6xl m-auto md:px-16 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-6 md:gap-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2 md:gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "dropdown",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        tabIndex: 0,
                                        className: "md:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "material-icons",
                                            children: "menu"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        tabIndex: 0,
                                        className: "menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                onClick: function() {
                                                    return router.pathname === "" ? handelScrollToFeatures() : handleRouteToHome("features");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Features"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/formulas",
                                                    children: "Formulas"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                tabIndex: 0,
                                                onClick: function() {
                                                    return router.pathname === "" ? handelScrollToPricing() : handleRouteToHome("pricing");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Pricing"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                onClick: function() {
                                                    return router.pathname === "" ? handelScrollToContact() : handleRouteToHome("contact");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Contact"
                                                })
                                            }),
                                            user && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/dashboard",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: router.pathname === "/dashboard" ? "text-primary" : "",
                                                        children: "Dashboard"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "flex items-center gap-4 text-lg md:text-xl md:font-bold ml-4 md:ml-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/graph.svg",
                                            alt: "logo",
                                            className: "h-8 w-8 md:h-12 md:w-12 "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "hidden md:block",
                                            children: "AI Excel Bot"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:flex font-semibold",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "flex gap-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: function() {
                                        return router.pathname === "" ? handelScrollToFeatures() : handleRouteToHome("features");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "p-2 rounded-2xl duration-300 text-gray-500 hover:text-green-900 hover:bg-green-200",
                                        children: "Features"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/formulas",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "p-2 rounded-2xl duration-300 text-gray-500 hover:text-green-900 hover:bg-green-200",
                                            children: "Formulas"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: function() {
                                        return router.pathname === "" ? handelScrollToPricing() : handleRouteToHome("pricing");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "p-2 rounded-2xl text-gray-500 duration-300 hover:text-green-900 hover:bg-green-200",
                                        children: "Pricing"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: function() {
                                        return router.pathname === "" ? handelScrollToContact() : handleRouteToHome("contact");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "p-2 rounded-2xl text-gray-500 duration-300 hover:text-green-900 hover:bg-green-200",
                                        children: "Contact"
                                    })
                                }),
                                user && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/dashboard",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "p-2 rounded-2xl text-gray-500 duration-300 hover:text-green-900 hover:bg-green-200",
                                                children: "Dashboard"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center gap-2 md:gap-4",
                children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "Large",
                    onClick: function() {
                        return logOut();
                    },
                    children: "Logout"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/signup",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "Large",
                                    children: "Signup"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/login",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.a */.E.a, {
                                className: "cursor-pointer px-3 py-1 md:px-6 md:py-3 font-semibold rounded-xl hover:bg-gray-200 duration-300 hover:text-black",
                                whileHover: {
                                    scale: 1.1
                                },
                                whileTap: {
                                    scale: 0.9
                                },
                                children: "Login"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);

;// CONCATENATED MODULE: ./components/Navbar/index.ts



/***/ }),

/***/ 4516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _stripe_products__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(896);
/* harmony import */ var _utils_AuthContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6864);





var PricingTable = function(param) {
    var showFree = param.showFree;
    var user = (0,_utils_AuthContext__WEBPACK_IMPORTED_MODULE_4__/* .useUser */ .a)().user;
    var _pricing = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var tempPricing = _stripe_products__WEBPACK_IMPORTED_MODULE_3__/* .pricing */ .D;
        // remove free items
        if (!showFree) {
            tempPricing = _stripe_products__WEBPACK_IMPORTED_MODULE_3__/* .pricing.filter */ .D.filter(function(p) {
                return p.title !== "Free";
            });
        }
        // remove items based on logged in user
        if (user) {
            tempPricing = tempPricing.filter(function(p) {
                return p.displayLoggedIn;
            });
        } else {
            tempPricing = tempPricing.filter(function(p) {
                return p.displayLoggedOut;
            });
        }
        return tempPricing;
    }, [
        showFree,
        user
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "mobile-padding-disable p-6 mx-auto max-w-screen-xl lg:py-16 lg:px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    gridTemplateColumns: "".concat(showFree ? "repeat(3, minmax(0, 400px))" : "repeat(2, minmax(0, 400px))")
                },
                className: "space-y-8 flex flex-wrap lg:grid sm:gap-6 xl:gap-6 lg:space-y-0 gap-6",
                children: _pricing.map(function(p, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative flex flex-col justify-between p-6 mx-auto max-w-lg text-center rounded-lg xl:p-8 ".concat(p.isAnnual ? "bg-gradient-to-b from-[#C0F4CC] to-[#F0FCF2] border border-[#419547] rounded-none rounded-b-lg" : "bg-white border-2"),
                        children: [
                            p.isAnnual && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    width: "calc(100% + 2px)"
                                },
                                className: "bg-[#419547] absolute -top-[36px] -left-[1px] h-[36px] flex items-center justify-center text-[12px] font-semibold text-[#FFFFFF] rounded-t-2xl",
                                children: "Best Value"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                className: "text-[23px] font-bold flex items-center justify-between text-left gap-2",
                                children: [
                                    p.title,
                                    p.isAnnual && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-[24px] text-[12px] px-2 bg-[#419547] text-[#FFFFFF] flex items-center justify-center rounded-full",
                                        children: "Save 30%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-[33px] font-extrabold leading-[40px] flex items-baseline",
                                children: [
                                    p.price,
                                    p.isAnnual ? "/year" : "/month"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-[1px] w-full ".concat(p.isAnnual ? "bg-[#419547]" : "bg-[#BFC2CA]", " my-4")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                role: "list",
                                className: "mb-8 space-y-4 text-left",
                                children: p.benefits.map(function(b, j) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: "flex items-center justify-between space-x-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    p.isAnnual ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: "/check-annual.svg",
                                                        alt: ""
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: "/check-default.svg",
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-[14px] text-[#2E3443]",
                                                        children: b
                                                    })
                                                ]
                                            }),
                                            b === "Access to our Chrome extension" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                width: 24,
                                                src: "/sheets-logo.svg",
                                                alt: ""
                                            }),
                                            b === "Access to our Excel add-in" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                width: 32,
                                                src: "/excel-logo.svg",
                                                alt: ""
                                            })
                                        ]
                                    }, j);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full",
                                children: user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/checkout/".concat(p.priceId, "/").concat(p.title),
                                    children: p.isAnnual ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "bg-[#6BD47B] w-full text-[#2E3443] font-bold h-[60px] rounded-lg border border-[#6BD47B]",
                                        children: "Upgrade to Pro"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "bg-[#FFFFFF] w-full text-[#2E3443] font-bold h-[60px] rounded-lg border border-[#2E3443]",
                                        children: "Upgrade to Pro"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: user ? "/dashboard" : "/signup",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: p.isAnnual ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "bg-[#6BD47B] w-full text-[#2E3443] font-bold h-[60px] rounded-lg border border-[#6BD47B]",
                                            children: "Get started"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "bg-[#FFFFFF] w-full text-[#2E3443] font-bold h-[60px] rounded-lg border border-[#2E3443]",
                                            children: "Get started"
                                        })
                                    })
                                })
                            })
                        ]
                    }, i);
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PricingTable);


/***/ }),

/***/ 3091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2070);


var Button = function(param) {
    var children = param.children, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _variant = param.variant, variant = _variant === void 0 ? "Default" : _variant, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _loadingText = param.loadingText, loadingText = _loadingText === void 0 ? "Loading..." : _loadingText, _type = param.type, type = _type === void 0 ? "button" : _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .motion.button */ .E.button, {
        type: type,
        className: "".concat(variant === "Default" ? "font-medium px-5 py-2.5" : "font-semibold px-6 py-3", " ").concat(loading ? "bg-green-600 cursor-not-allowed" : "bg-green-400 hover:bg-green-600 hover:text-white", " text-center text-sm rounded-xl duration-300 flex items-center"),
        whileHover: {
            scale: 1.1
        },
        whileTap: {
            scale: 0.9
        },
        onClick: onClick,
        disabled: loading,
        children: !loading ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    "aria-hidden": "true",
                    role: "status",
                    className: "inline w-4 h-4 mr-3 text-white animate-spin",
                    viewBox: "0 0 100 101",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                            fill: "#E5E7EB"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                            fill: "currentColor"
                        })
                    ]
                }),
                loadingText
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/index.mjs
var es_value = __webpack_require__(3234);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
var MotionConfigContext = __webpack_require__(6014);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(6681);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-motion-value.mjs





/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    const value = (0,use_constant/* useConstant */.h)(() => (0,es_value/* motionValue */.B)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    const { isStatic } = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._);
    if (isStatic) {
        const [, setLatest] = (0,react.useState)(initial);
        (0,react.useEffect)(() => value.on("change", setLatest), []);
    }
    return value;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(4606);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/transform.mjs


const isCustomValueType = (v) => {
    return typeof v === "object" && v.mix;
};
const getMixer = (v) => (isCustomValueType(v) ? v.mix : undefined);
function transform(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, {
        mixer: getMixer(outputRange[0]),
        ...options,
    });
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/frameloop/index.mjs + 2 modules
var frameloop = __webpack_require__(404);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(8868);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-combine-values.mjs




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    const value = useMotionValue(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    const updateValue = () => value.set(combineValues());
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(() => {
        const scheduleUpdate = () => frameloop/* sync.update */.Z_.update(updateValue, false, true);
        const subscriptions = values.map((v) => v.on("change", scheduleUpdate));
        return () => {
            subscriptions.forEach((unsubscribe) => unsubscribe());
            frameloop/* cancelSync.update */.qY.update(updateValue);
        };
    });
    return value;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs




function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    const transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], ([latest]) => transformer(latest));
}
function useListTransform(values, transformer) {
    const latest = (0,use_constant/* useConstant */.h)(() => []);
    return useCombineMotionValues(values, () => {
        latest.length = 0;
        const numValues = values.length;
        for (let i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 161 modules
var motion = __webpack_require__(2070);
// EXTERNAL MODULE: ./components/Navbar/index.ts + 1 modules
var Navbar = __webpack_require__(9419);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(9057);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./utils/AuthContext.tsx
var AuthContext = __webpack_require__(6864);
// EXTERNAL MODULE: ./components/Pricing/PricingTable.tsx
var PricingTable = __webpack_require__(4516);
// EXTERNAL MODULE: ./components/ContactForm/ContactForm.tsx
var ContactForm = __webpack_require__(5328);
// EXTERNAL MODULE: ./components/Utils/Button.tsx
var Button = __webpack_require__(3091);
;// CONCATENATED MODULE: ./pages/index.tsx













var sectionVariantProps = {
    initial: "hidden",
    whileHover: "hover",
    whileInView: "visible",
    viewport: {
        once: true
    },
    transition: {
        duration: 0.3
    },
    variants: {
        visible: {
            opacity: 1,
            backgroundImage: "linear-gradient(to right bottom, #f3f3f6, #f6f6f8, #f9f9fa, #fcfcfd, #ffffff)"
        },
        hidden: {
            opacity: 0
        },
        hover: {
            scale: 1.01,
            backgroundImage: "linear-gradient(to right bottom, #bbf7d0, #c9f9d9, #d6fae2, #e3fceb, #f0fdf4)"
        }
    }
};
var pricingSectionProps = {
    initial: "hidden",
    whileInView: "visible",
    viewport: {
        once: true
    },
    transition: {
        duration: 0.3
    },
    variants: {
        visible: {
            opacity: 1
        },
        hidden: {
            opacity: 0
        }
    }
};
var Home = function() {
    var handleMouse = function handleMouse(event) {
        x.set(event.pageX);
        y.set(event.pageY);
    };
    var router = (0,next_router.useRouter)();
    var user = (0,AuthContext/* useUser */.a)().user;
    var featuresRef = (0,react.useRef)(null);
    var pricingRef = (0,react.useRef)(null);
    var contactRef = (0,react.useRef)(null);
    var x = useMotionValue(200);
    var y = useMotionValue(200);
    var rotateX = useTransform(y, [
        0,
        400
    ], [
        10,
        -10
    ]);
    var rotateY = useTransform(x, [
        0,
        400
    ], [
        -10,
        10
    ]);
    (0,react.useEffect)(function() {
        if (router.query) {
            var anchor = router.query.anchor;
            if (anchor === "features") {
                // @ts-ignore
                featuresRef.current.scrollIntoView({
                    behavior: "smooth"
                });
            }
            if (anchor === "pricing") {
                // @ts-ignore
                pricingRef.current.scrollIntoView({
                    behavior: "smooth"
                });
            }
            if (anchor === "contact") {
                // @ts-ignore
                contactRef.current.scrollIntoView({
                    behavior: "smooth"
                });
            }
        }
    }, [
        router.query
    ]);
    var handleCTAClick = (0,react.useCallback)(function() {
        return user ? router.push("/dashboard") : router.push("/signup");
    }, [
        router,
        user
    ]);
    var handelScrollToFeatures = (0,react.useCallback)(function() {
        return(// @ts-ignore
        featuresRef.current.scrollIntoView({
            behavior: "smooth"
        }));
    }, []);
    var handelScrollToPricing = (0,react.useCallback)(function() {
        return(// @ts-ignore
        pricingRef.current.scrollIntoView({
            behavior: "smooth"
        }));
    }, []);
    var handelScrollToContact = (0,react.useCallback)(function() {
        return(// @ts-ignore
        contactRef.current.scrollIntoView({
            behavior: "smooth"
        }));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "AI Excel Bot | Use AI To Generate Excel Formulas In Seconds",
                description: "AI Excel Bot helps you create complex Excel formulas in seconds. Use simple English prompts to generate formulas. AI Excel Bot's formula generator uses state of the art GPT-3 AI model to give you the best results.",
                canonical: "https://aiexcelbot.com",
                openGraph: {
                    url: "https://aiexcelbot.com",
                    title: "AI Excel Bot | Use AI To Generate Excel Formulas In Seconds",
                    description: "AI Excel Bot helps you create complex Excel formulas in seconds. Use simple English prompts to generate formulas. AI Excel Bot's formula generator uses state of the art GPT-3 AI model to give you the best results.",
                    images: [
                        {
                            url: "https://aiexcelbot.com/dashboard-hero.png"
                        }
                    ],
                    siteName: "AI Excel Bot"
                },
                twitter: {
                    handle: "@0x_gautam",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute -z-10 top-0 blur-xl h-screen w-full bg-gradient-to-br from-green-100 to-transparent"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "scrollbar-thin scrollbar-thumb-gray-500 overflow-y-scroll overflow-x-hidden scrollbar-thumb-rounded-full scrollbar-track-rounded-full px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-6xl m-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar */.w, {
                            handelScrollToContact: handelScrollToContact,
                            handelScrollToFeatures: handelScrollToFeatures,
                            handelScrollToPricing: handelScrollToPricing
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, {
                        initial: "hidden",
                        whileInView: "visible",
                        viewport: {
                            once: true
                        },
                        transition: {
                            duration: 0.3
                        },
                        variants: {
                            visible: {
                                opacity: 1
                            },
                            hidden: {
                                opacity: 0
                            }
                        },
                        className: "min-h-[90vh] max-w-6xl mx-auto md:mt-12 py-6 md:py-12 md:px-0",
                        onMouseMove: handleMouse,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto max-w-3xl text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-3xl font-bold md:text-5xl",
                                            children: "Write Excel and Google Sheets Formulas 10x Faster With AI"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "py-6 text-lg",
                                            children: "Generate complex formulas using simple text instructions in seconds."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mx-auto w-max",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                onClick: handleCTAClick,
                                                variant: "Large",
                                                children: "Get Started"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                    style: {
                                        rotateX: rotateX,
                                        rotateY: rotateY
                                    },
                                    className: "mockup-window max-w-3xl mx-auto mt-8 overflow-visible border-2",
                                    initial: "hidden",
                                    whileInView: "visible",
                                    viewport: {
                                        once: true
                                    },
                                    transition: {
                                        duration: 0.9
                                    },
                                    variants: {
                                        visible: {
                                            y: 0,
                                            opacity: 1
                                        },
                                        hidden: {
                                            y: 50,
                                            opacity: 0
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "px-4 py-8 border-t-2 ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative sm:-left-8 md:-left-16 mb-4 rounded-xl bg-green-200 sm:w-96 px-4 py-2 ",
                                                children: "Sum column A when cell B10 equals the word hello"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative sm:left-[60%] md:left-[75%] mb-4 rounded-xl bg-green-600 text-white sm:w-60 px-4 py-2 ",
                                                children: '=SUMIF(B10,"hello",A:A)'
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative sm:-left-8 md:-left-16 mb-4 rounded-xl bg-green-200 sm:w-96 px-4 py-2 ",
                                                children: "=VLOOKUP(B3,$F$3:$G$8,2,FALSE)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative sm:left-[45%] md:left-[65%] rounded-xl bg-green-600 text-white sm:w-96 px-4 py-2 ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "1. The formula is a VLOOKUP formula."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "2. It looks up the value in cell B3."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "3. It looks for the value in the range of cells from F3 to G8."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "4. It returns the value from the second column of the range (G3:G8)."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "5. It does not approximate the value if it is not found (FALSE)."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-6xl mx-auto py-20 grid grid-cols-1 gap-4 items-stretch",
                        ref: featuresRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionVariantProps), {
                                className: "p-8 rounded-3xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col lg:flex-row-reverse gap-16 items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-center lg:text-left flex-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "text-5xl font-bold",
                                                    children: "Generate Formulas"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "py-6 text-lg",
                                                    children: "Easily generate Excel or Google Sheets formulas with simple text prompts."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "rounded-xl border border-green-700 overflow-hidden flex-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/generate.png",
                                                alt: "Generate Excel And Google Sheets Formulas",
                                                className: "w-full"
                                            })
                                        })
                                    ]
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: "p-8 rounded-3xl"
                            }, sectionVariantProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col-reverse lg:flex-row-reverse gap-16 items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "rounded-xl border border-green-700 overflow-hidden flex-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/explain.png",
                                                alt: "Let the AI help you understand complex formulas in seconds.",
                                                className: "w-full"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-center md:text-left flex-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "text-5xl font-bold",
                                                    children: "Understand Complex Formulas"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "py-6 text-lg",
                                                    children: "No need to scratch your head to understand complex Excel or Google Sheets formulas. Let the AI help you do that."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: "p-8 rounded-3xl"
                            }, sectionVariantProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col lg:flex-row-reverse gap-16 items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-center md:text-left flex-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "text-5xl font-bold",
                                                    children: "VBA Code Support"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "py-6 text-lg",
                                                    children: "No need to waste time writing or understanding VBA. AI Excel Bot can write VBA and explain it to you in seconds."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "rounded-xl border border-green-700 overflow-hidden flex-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/vba.png",
                                                alt: "Let the AI help you understand complex formulas in seconds.",
                                                className: "w-full"
                                            })
                                        })
                                    ]
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: "p-8 rounded-3xl"
                            }, sectionVariantProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col-reverse lg:flex-row-reverse gap-16 items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "rounded-xl border border-green-700 overflow-hidden flex-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/addon.png",
                                                alt: "Let the AI help you understand complex formulas in seconds.",
                                                className: "w-full"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-center lg:text-left flex-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "text-5xl font-bold",
                                                    children: "Chrome Addon"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "py-6 text-lg",
                                                    children: "Use the power of AI without leaving Google Sheets or Excel."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://chrome.google.com/webstore/detail/ai-excel-bot-extension/ehpdalbmeiockgpaikchiciodighaedg",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    className: "flex justify-center md:justify-start",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        variant: "Large",
                                                        children: "Download Extension"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: "py-20 px-10 max-w-6xl mx-auto",
                        ref: pricingRef
                    }, pricingSectionProps), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col-reverse lg:flex-row gap-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-5xl font-bold",
                                        children: "Simple Pricing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "py-6 text-lg",
                                        children: "For all kind of users."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingTable/* default */.Z, {
                                        showFree: true
                                    })
                                ]
                            })
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-6xl mx-auto my-10 bg-gradient-to-r from-green-200 to-green-50 p-8 rounded-3xl flex flex-col md:flex-row gap-4 md:justify-around items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-3xl text-center sm:text-left font-bold",
                                children: "Access the power of AI"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.button */.E.button, {
                                className: "\n          text-lg font-bold px-8 p-4 bg-green-600 text-white text-center rounded-xl duration-300 flex items-center",
                                whileHover: {
                                    scale: 1.1
                                },
                                whileTap: {
                                    scale: 0.9
                                },
                                onClick: handleCTAClick,
                                children: "Get Started"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pricingSectionProps), {
                        className: "max-w-6xl mx-auto",
                        ref: contactRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-8 lg:py-16 px-4 mx-auto max-w-screen-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm/* default */.Z, {
                                title: "Contact Us",
                                subtitle: "Got a technical issue? Want to send feedback about a feature? Get in touch with the founder."
                            })
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                handelScrollToContact: handelScrollToContact,
                handelScrollToFeatures: handelScrollToFeatures,
                handelScrollToPricing: handelScrollToPricing
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ pricing; }
/* harmony export */ });
var pricing = [
    {
        title: "Free",
        price: "$0",
        priceId: "",
        benefits: [
            "Limited access to AI Excel Bot",
            "5 Formula, Code or Task generation and explaination per month",
            "Access to our Chrome extension",
            "email support", 
        ],
        isLocal: true,
        displayLoggedIn: false,
        displayLoggedOut: true,
        paypal_plan_id: ""
    },
    {
        title: "Pro",
        price: "$5.99",
        priceId: "price_1OqWpWGUC8HbciH8h68KMVAH",
        benefits: [
            "Full access to AI Excel Bot",
            "Access to our Chrome extension",
            "Access to our Excel add-in",
            "Unlimited Formula generation per month",
            "Unlimited Formula explanations per month",
            "Unlimited VBA code generations per month",
            "Unlimited VBA code explanations per month",
            "Unlimited Task explanations per month",
            "Priority support", 
        ],
        isLocal: false,
        isAnnual: false,
        displayLoggedIn: true,
        displayLoggedOut: true,
        paypal_plan_id: "P-9AG89956MN843883MMXSYXII"
    },
    {
        title: "Pro Annual",
        price: "$49.99",
        priceId: "price_1OqWuwGUC8HbciH8pjYB8MQh",
        benefits: [
            "Full access to AI Excel Bot",
            "Access to our Chrome extension",
            "Access to our Excel add-in",
            "Unlimited Formula generation per month",
            "Unlimited Formula explanations per month",
            "Unlimited VBA code generations per month",
            "Unlimited VBA code explanations per month",
            "Unlimited Task explanations per month",
            "Priority support", 
        ],
        isLocal: false,
        isAnnual: true,
        displayLoggedIn: true,
        displayLoggedOut: true,
        paypal_plan_id: "P-7AM83542T77522743MXSYYII"
    }, 
];


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,70,962,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);